<template>
  <div>
    <h4>Kategorien</h4>
    <div class="card p-3">
      <div class="mb-3" v-if="parentCollections.length > 0">
        <b-badge class="mr-1" v-for="collection in parentCollections" :key="collection.id">{{collection.title}}</b-badge>
      </div>
      <Multiselect
          v-if="collections.length > 0"
          v-model="value" :options="collections"
          :searchable="true"
          :allow-empty="true"
          :multiple="true"
          placeholder="Kategorien suchen und auswählen"
          tagPlaceholder="Tag"
          selectedLabel="Ausgewählt"
          grouplabel="title"
          track-by="id"
          group-values="children"
          group-label="title"
          label="title"
          deselectLabel="Klick oder Enter zum entfernen"
          selectLabel="Klick oder Enter zum auswählen"
          @input="hasChanged"
      >
        <span slot="noResult">Keine Ergebnisse gefunden.</span>
      </Multiselect>
      <div>
          <b-spinner v-if="inProgress" small style="position: absolute; right: 15px; top: 15px;"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import products from "@/api/products";
import collections from "@/api/collections";
import { Multiselect } from 'vue-multiselect'

export default {
  props: ['productCollections'],
  inject: ['showSuccessAlert'],
  components: {
    Multiselect
  },
  data() {
    return {
      collections: [],
      childParentCollectionMapping: {},
      currentProductCollections: this.productCollections.filter(this.filterTax).map(this.mapCollection),
      selectedCollections: [],
      parentCollections: [],
      inProgress: false,
      value: []
    }
  },
  created() {
    this.selectedCollections = this.productCollections.filter(this.filterTax).map(c => c.id);
    collections.get().then(
        response => {
          this.collections = response.map(
              collection => (
                  {
                    ...collection,
                    children: collection.children.filter(this.filterTax)
                  }
              )
          )

          this.childParentCollectionMapping = this.collections.reduce(
              (mapping, parent) => {
                parent.children.map( child => {
                  if (parent.id !== null) {
                    mapping[child.id] = parent.id
                  }
                })
                return mapping
              },
              {}
          )
        }
    ).finally(async () => {
        await this.setParentCollections()
        this.value = await this.productCollections.filter(this.filterTax).filter(e => !this.parentCollections.map(x => x.id).includes(e.id))
    }
    )

  },
  computed: {
    productId () {
      return this.$route.params.id
    },
    currentProductCollectionsIds(){
      return this.currentProductCollections.map(collection => collection.value)
    },
    selectedParentCollectionIds: function () {
      return new Set(this.selectedCollections.map(id => this.childParentCollectionMapping[id]).filter(id => id !== undefined))
    },
    parentCollectionIds(){
      return this.collections.map(collection => collection.id).filter(id => id !== null)
    }
  },
  methods: {
    hasChanged(e) {
        this.selectedCollections = e.map(e => e.id)
        this.setParentCollections()
        this.onSaveButton()
    },
    filterTax(collection){
      return !collection.title.startsWith('tax_')
    },
    setParentCollections() {
        this.parentCollections = this.collections.map(k => {
            const fnew = k.children.filter(e => this.selectedCollections.includes(e.id) || this.currentProductCollections.map(e => e.value).includes(e.id))
            if (fnew.length === 0) return
            return {
                id: k.id || undefined,
                title: k.title || k.text
            }
        }).filter(e => e)
    },
    mapCollection(collection){
      return {
        value: collection.id,
        text: collection.title
      }
    },
    addParentCollectionIds(collectionIds){
      const childParentMapping = this.childParentCollectionMapping
      let parentIds = collectionIds.map(id => {
        if (childParentMapping[id] !== undefined) {
          return childParentMapping[id]
        }
      }).filter(id => id !== null && id !== undefined)

      return collectionIds.concat(parentIds)
    },
    removeParentCollections(collections){
      return collections.filter(collection => !this.parentCollectionIds.includes(collection.id))
    },
    onSaveButton(){
      this.inProgress = true;
      let collectionsToLeave = this.currentProductCollectionsIds.filter(collectionId => !this.selectedCollections.includes(collectionId))
      let collectionsToJoin = this.selectedCollections.filter(collectionId => !this.currentProductCollectionsIds.includes(collectionId))
      collectionsToJoin = this.addParentCollectionIds(collectionsToJoin)
      collectionsToLeave = this.addParentCollectionIds(collectionsToLeave).filter(collection => !this.selectedParentCollectionIds.has(collection))
      products.put(
          this.productId,
          {
            collectionsToJoin: collectionsToJoin,
            collectionsToLeave: collectionsToLeave
          }
      )
      .then(response => {
        this.currentProductCollections = response.data.collections.filter(
               this.filterTax
        ).map(this.mapCollection)
        this.showSuccessAlert('Änderung ist gespeichert')
      })
      .catch(
          () => this.$bvModal.show('error-modal')
      ).finally(() => {
              this.setParentCollections()
              this.inProgress=false
          }
      )

    },
    add() {
      this.inProgress = true;
      products.put(this.productId, {collectionsToJoin: this.selectedCollections, id: this.productId}).then(
          response => {
            this.inProgress = false;
            this.currentProductCollections = response.data.collections.filter(
                this.filterTax
            ).map(this.mapCollection)
          }).catch(
          () => {
            this.inProgress = false;
            this.$bvModal.show('error-modal')
          }
      )
    },
    remove(collectionId) {
      this.inProgress = true;
      products.put(
          this.productId,
          {
            id: this.productId,
            collectionsToLeave: [collectionId]
          }
      ).then(
          response => {
            this.inProgress = false;
            this.currentProductCollections =response.data.collections.filter(
                this.filterTax
            ).map(this.mapCollection)
          }
      ).catch(
          () => {
            this.inProgress = false;
            this.$bvModal.show('error-modal')
          }
      )
    }
  }
}
</script>
